var _style, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 920 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .small {\n        font: 150px times-new-roman;\n        fill: white;\n        text-anchor: middle\n\n\n        }\n        .heavy {\n        font: 39px arial;\n        fill: #cccccc;\n        text-anchor: middle;\n        letter-spacing: 10px;\n\n        }\n\n    ")), /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 100,
    className: "small"
  }, "\n        n", /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "Courier",
      fontSize: 180
    }
  }, "o"), "ctuRNA\n    "), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 160,
    className: "heavy"
  }, "CIRCULAR MRNA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLogoLight);
export default __webpack_public_path__ + "static/media/base_logo_light.46c504a9f82421c51e629fc0e93752b0.svg";
export { ForwardRef as ReactComponent };